import { action } from '@ember/object';
import { service } from '@ember/service';
// eslint-disable-next-line ember/no-mixins
import FastbootHelpersMixin from 'client-portal/mixins/route/fastboot-helpers';
import Route from '@ember/routing/route';

const ExtendedRoute = Route.extend(FastbootHelpersMixin);

export default class SiteBillingInsuranceNew extends ExtendedRoute {
  @service currentPractice;
  @service analytics;
  @service router;
  @service store;
  @service clientInsuranceAccess;

  get insuranceFeatureEnabled() {
    return this.clientInsuranceAccess.claimAssistantOrManagedBilling;
  }

  beforeModel() {
    super.beforeModel(...arguments);

    if (!this.insuranceFeatureEnabled) {
      return this.router.transitionTo('site.billing');
    }

    let client = this.modelFor('site.billing');
    if (!client) {
      return this.router.transitionTo('site.billing');
    }
  }

  async model() {
    let client = this.modelFor('site.billing');

    let newInsurance = this.store.createRecord('insurance-info-request-connection', {
      client,
      insuredRelation: '0', // Default to 'Self'
      isDirty: false,
    });

    this.analytics.track('Client Insurance Info Submission Started', {
      object: 'Client Insurance Info Submission',
      action: 'Started',
    });

    // Initialize the documents relationship
    await newInsurance.documents;

    return {
      client,
      insuranceInfoRequestConnection: newInsurance,
    };
  }

  @action
  willTransition() {
    if (!this.controller.isSubmitted) {
      this.analytics.track('Client Insurance Info Submission Abandoned', {
        object: 'Client Insurance Info Submission',
        action: 'Abandoned',
      });
    }
  }
}
